import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconAdd } from '../../assets/icons';
import { IconDelete } from '../../assets/icons/icon-delete';
import { ButtonText, CircularProgress, EmptyStateBox, Header, NavHeader, Page } from '../../components';
import ArrowButton from '../../components/arrow-button';
import { useCredentials } from './hooks/use-credentials';

const Credentials: React.FC = () => {
  const { t } = useTranslation('profile');
  const { totp, passwordless, configureTOTP, configurePasswordless, handleRemoveCredential } = useCredentials();

  return (
    <Page
      header={
        <>
          <NavHeader />
          <Header title={t('credentials.configureOptions')} isUnderline />
        </>
      }
    >
      <Header
        title={t('credentials.twoFactorAuth.header')}
        subtitle={t('credentials.twoFactorAuth.description')}
        column
      >
        <ButtonText type="accent" onClick={configureTOTP} size="small" sx={{ paddingLeft: 0 }}>
          <IconAdd className="m-r-8" />
          {t('credentials.twoFactorAuth.button')}
        </ButtonText>
      </Header>

      <div className="grid-list-24 m-b-48">
        {totp.loading ? (
          <CircularProgress />
        ) : totp.credentials && totp.credentials.length ? (
          totp.credentials?.map(({ credential }) => (
            <ArrowButton
              key={credential.id}
              title={credential.userLabel}
              onClick={() => handleRemoveCredential(credential.id)}
              className="m-b-24"
              small
              arrowIcon={<IconDelete red />}
            />
          ))
        ) : (
          <EmptyStateBox content={t('credentials.twoFactorAuth.empty')} />
        )}
      </div>

      <Header
        title={t('credentials.passwordlessKeys.header')}
        subtitle={t('credentials.passwordlessKeys.description')}
        column
      >
        <ButtonText type="accent" onClick={configurePasswordless} size="small" sx={{ paddingLeft: 0 }}>
          <IconAdd className="m-r-8" />
          {t('credentials.passwordlessKeys.button')}
        </ButtonText>
      </Header>

      <div className="grid-list-24 m-b-24">
        {passwordless.loading ? (
          <CircularProgress />
        ) : passwordless.credentials && passwordless.credentials.length ? (
          passwordless.credentials?.map(({ credential }) => (
            <ArrowButton
              key={credential.id}
              title={credential.userLabel}
              onClick={() => handleRemoveCredential(credential.id)}
              className="m-b-24"
              small
              arrowIcon={<IconDelete red />}
            />
          ))
        ) : (
          <EmptyStateBox content={t('credentials.passwordlessKeys.empty')} />
        )}
      </div>
    </Page>
  );
};

export default Credentials;
